import { createApp } from '@backstage/frontend-defaults';
import authPlugin from '@backstage/plugin-auth';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import catalogLandingPlugin from '@internal/plugin-catalog-landing';
import { catalogGridModule } from '@internal/plugin-catalog-grid';
import releaseManagerPlugin from '@internal/plugin-release-manager';
import { themeModule } from './theme';
import { oneloginAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => (
      <SignInPage
        {...props}
        provider={{
          id: 'onelogin-auth-provider',
          title: 'OneLogin',
          message: 'Sign in using OneLogin',
          apiRef: oneloginAuthApiRef,
        }}
      />
    ),
  },
});

export default createApp({
  features: [
    catalogPlugin,
    catalogGridModule,
    navModule,
    catalogLandingPlugin,
    releaseManagerPlugin,
    authPlugin,
    themeModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
